export type ParamType = 'slider' | 'color' | 'color-ramp' | 'toggle' | 'select' | 'text';

export interface BaseParam {
  id: string;
  label: string;
  type: ParamType;
  group?: string;
  tooltip?: string;
  locked?: boolean;  // If true, randomization skips this param
  lockedByDefault?: boolean;  // Initial locked state
}

export interface SliderParam extends BaseParam {
  type: 'slider';
  min: number;
  max: number;
  step: number;
  default: number;
}

export interface ColorParam extends BaseParam {
  type: 'color';
  default: string;  // hex color
}

export interface ColorRampParam extends BaseParam {
  type: 'color-ramp';
  default: [string, string, string];  // low, mid, high hex colors
}

export interface ToggleParam extends BaseParam {
  type: 'toggle';
  default: boolean;
}

export interface SelectParam extends BaseParam {
  type: 'select';
  options: { value: string; label: string }[];
  default: string;
}

export interface TextParam extends BaseParam {
  type: 'text';
  default: string;
  placeholder?: string;
}

export type Param = SliderParam | ColorParam | ColorRampParam | ToggleParam | SelectParam | TextParam;

export interface ParamGroup {
  id: string;
  label: string;
  collapsible?: boolean;
  collapsedByDefault?: boolean;
}

export interface ModeDefinition {
  id: string;
  name: string;
  modeIndex: number;  // Maps to Rust SkyMode enum
  groups: ParamGroup[];
  params: Param[];
  // Function to randomize values (mode-specific logic)
  randomize?: (currentValues: Record<string, unknown>, lockedParams: Set<string>) => Record<string, unknown>;
}

// Runtime state for a parameter
export interface ParamState {
  value: unknown;
  locked: boolean;
}

// All parameter values for rendering
export interface RenderSettings {
  mode: number;
  seed: string;
  [key: string]: unknown;
}
